import { Box, Typography, useTheme } from "@mui/material";
import { useTaskerMessageContext } from "./TaskerMessageContext";

export const ReviewHeader = () => {
  const theme = useTheme();
  const { taskerAssignedMessages } = useTaskerMessageContext();
  const pendingCount = taskerAssignedMessages.length;
  return (
    <Box
      sx={{
        mb: { xs: 2.5, sm: 3 },
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 4%, ${theme.palette.primary.light} 100%)`,
        borderRadius: { xs: 2, sm: 2.5 },
        p: { xs: 2, sm: 2.5 },
        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.25)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h5"
          data-cypress="pending-messages-count"
          sx={{
            color: "white",
            fontWeight: 700,
            textAlign: "center",
            fontSize: { xs: "1.25rem", sm: "1.5rem" },
          }}
        >
          {pendingCount} pending {pendingCount === 1 ? "message" : "messages"}{" "}
          left to review
        </Typography>
      </Box>
    </Box>
  );
};
